import * as React from "react";
import API from "../api";
import { useCurrentUser } from "../auth";

export const defaultValue = {
  allFolders: [],
  getAllFolders: () => null,
  getFilesByParent: () => null,
  getFoldersByParent: () => null,
};
const FoldersContext = React.createContext(defaultValue);

export function FoldersProvider({ children }) {
  const { data } = useCurrentUser();
  const isLoggin = data?.loggedIn;
  const [allFolders, setAllFolders] = React.useState(defaultValue.allFolders);
  const getAllFolders = React.useCallback(() => {
    API.get("folders/all")
      .then((res) => {
        setAllFolders(res.data);
      })
      .catch(() => {
        //TODO: Add additional err handling here
      });
  }, []);

  const getFoldersByParent = React.useCallback(async (parentId) => {
    return await API.get(`/getFoldersByParent?parentID=${parentId}`).catch(
      () => {
        //TODO: Add additional err handling here
      }
    );
  }, []);
  const getFilesByParent = React.useCallback(async (parentId) => {
    return API.get(`/getFilesByFolder?folder_id=${parentId}`).catch(() => {
      //TODO: Add additional err handling here
    });
  }, []);

  React.useEffect(() => {
    if (isLoggin) {
      getAllFolders();
    }
  }, [isLoggin]);
  const value = React.useMemo(
    () => ({
      allFolders,
      getAllFolders,
      getFilesByParent,
      getFoldersByParent,
    }),
    [allFolders, getAllFolders, getFilesByParent, getFoldersByParent]
  );
  return (
    <FoldersContext.Provider value={value}>{children}</FoldersContext.Provider>
  );
}
export const useAllFolders = () => {
  const contextValues = React.useContext(FoldersContext);

  if (contextValues === undefined) {
    throw new Error("useAllFolders must be used within a FoldersProvider");
  }

  return { ...contextValues };
};
